import React from 'react'
import { IconButton } from '@st-operations/uikit/src/v2'

import './styles.scss'

export function ExportButton({ data, filename = 'export.csv', children }) {
  const handleExportDataAsCSV = () => {
    const replacer = (_, value) => (value === null ? '' : value)
    const header = Object.keys(data[0])
    let csv = data.map((row) =>
      header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(',')
    )
    csv.unshift(header.join(','))
    csv = csv.join('\r\n')

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })

    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    link.click()
  }

  return (
    <div className="export-button">
      <IconButton
        onClick={handleExportDataAsCSV}
        classes={{ button: 'export-button__button' }}
        iconProps={{
          icon: 'download',
          color: 'currentColor',
          width: 24,
          height: 24,
        }}
        text="Export as CSV"
      >
        <span>{children}</span>
      </IconButton>
    </div>
  )
}
